var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Horizontal container"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1667 15.1324V13.7157C14.1667 12.9643 13.8681 12.2436 13.3368 11.7123C12.8054 11.1809 12.0848 10.8824 11.3333 10.8824H5.66666C4.91521 10.8824 4.19455 11.1809 3.66319 11.7123C3.13184 12.2436 2.83333 12.9643 2.83333 13.7157V15.1324",
    stroke: "#1DC9A0",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.50001 8.04908C10.0648 8.04908 11.3333 6.78056 11.3333 5.21575C11.3333 3.65094 10.0648 2.38242 8.50001 2.38242C6.9352 2.38242 5.66667 3.65094 5.66667 5.21575C5.66667 6.78056 6.9352 8.04908 8.50001 8.04908Z",
    stroke: "#1DC9A0",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileGreen);
export default __webpack_public_path__ + "static/media/profile-green.8cf7d0fb1d5d67b65fd0534f44e79a33.svg";
export { ForwardRef as ReactComponent };